<template>
  <v-layout>
    <v-app-bar :elevation="2">
      <template v-slot:prepend>
        <img class="image-header" src="/is-global.png?v=0.0.1" alt="" srcset="" />
      </template>
      <v-spacer></v-spacer>

      <v-btn icon @click="logout">
        <v-icon>mdi-logout</v-icon>
      </v-btn>
    </v-app-bar>

    <v-main>
      <v-container>
        <slot />
      </v-container>
    </v-main>
  </v-layout>
</template>

<script lang="ts">
import { useRouter } from 'vue-router'
import { useAuth } from '@/composables/useAuth'

export default {
  name: 'AppNavbar', // Ensure the component name is multi-word
  setup() {
    const router = useRouter()
    const { logout: msalLogout, isAuthenticated } = useAuth()

    const logout = async () => {
      // Check if user is authenticated via Microsoft
      if (isAuthenticated.value) {
        await msalLogout()
      } else {
        // Traditional logout
        localStorage.removeItem('token')
        router.push({ path: '/login' })
      }
    }

    return {
      logout,
    }
  },
}
</script>

<style scoped>
/* Add any styles here */
.image-header {
  width: auto;
}
</style>
